import React, { useState, useEffect, useContext, useRef } from "react"
import {
  Dialog,
  DialogContent,
  TextField,
  Grid,
  Slide,
  InputAdornment,
  ClickAwayListener,
  Popper,
  Paper,
} from "@material-ui/core"
import { AuthContext } from "../../context/Auth/AuthContext"
import { Autocomplete } from "@material-ui/lab"
import { ChevronDown, Search, X } from "lucide-react"
import api from "../../services/api"
import { useSituacaoStore } from "../../stores/situacaoStore"
import DefaultButton from "../DefaultButton"
import Modal from "../Modal"
import { useLocation } from "react-router-dom"
import ContactList from "../ContactList"
import Checkbox from "../atoms/checkbox"

import useStyles from "./FiltroKanbanModalStyles"

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} timeout={500} />
})

const oFiltrosKanbanVazio = {
  queues: [],
  situacoes: [],
  users: [],
  empresa: "",
  motivo: [],
  contatos: [],
  contatosSelecionados: [],
  lidas: true,
}

const FilterModal = ({ open, onClose, onApplyFilters, mFilasUsuario, filters = oFiltrosKanbanVazio }) => {
  const [mFilasSelecionadas, setFilasSelecionadas] = useState([])
  const [mSituacoesSelecionadas, setSituacoesSelecionadas] = useState([])
  const [mUsuariosSelecionados, setUsuariosSelecionados] = useState([])
  const [cEmpresa, setEmpresa] = useState("")
  const [mMotivos, setMotivos] = useState([])
  const [mContatosSelecionados, setContatosSelecionados] = useState([])
  const [lLidas, setLidas] = useState(true)
  const [queues, setQueues] = useState([])
  const [situacoes, setSituacoes] = useState([])
  const [users, setUsers] = useState([])
  const [motivos, setMotivosOpcoes] = useState([])
  const [searchParam, setSearchParam] = useState("")
  const [abrirDropdownContatos, setAbrirDropdownContatos] = useState(false)
  const contatoFieldRef = useRef(null)
  const contatoDropdownRef = useRef(null)
  const location = useLocation()
  const classes = useStyles()

  const { user } = useContext(AuthContext)

  useEffect(() => {
    const fetchQueues = async () => {
      try {
        let newQueues = [{ id: 0, name: "Todas" }]
        if (user.allTicket === "enabled" || user.profile === "admin") {
          newQueues.push({ id: null, name: "Sem fila" })
        }
        newQueues = newQueues.concat(user.queues)
        setQueues(newQueues)
      } catch (err) {
        console.error("Falha ao acessar filas", err)
      }
    }

    const fetchSituacoes = async () => {
      try {
        const data = await useSituacaoStore.getState().listaSimplesObter()
        const situacaoList = data.map((s) => ({ id: s.id, name: s.name }))
        setSituacoes([{ id: 0, name: "Todas" }, ...situacaoList])
      } catch (err) {
        console.error("Falha ao acessar situacoes", err)
      }
    }

    const fetchUsers = async () => {
      try {
        const { data } = await api.get(`/users/list`, {
          params: { validarPermissaoPerfil: true, somenteAtivos: true },
        })
        const userList = data.map((u) => ({ id: u.id, name: u.name }))
        setUsers([{ id: 0, name: "Todos" }, ...userList])
      } catch (err) {
        console.error("Falha ao acessar usuarios", err)
      }
    }

    const fetchMotivos = async () => {
      try {
        const { data } = await api.get("/motivos-contato/list")
        setMotivosOpcoes([{ id: 0, descricao: "Todos" }, ...(data || [])])
      } catch (err) {
        console.error("Falha ao acessar motivos!", err)
      }
    }

    fetchMotivos()
    fetchQueues()
    fetchSituacoes()
    fetchUsers()
  }, [])

  /** Restaura campos do modal com os filtros já aplicados (ex.: ao voltar de outra tela). */
  useEffect(() => {
    if (!open) return

    const mapearOpcoesSelecionadas = (oSelecionados, mOpcoes) =>
      (oSelecionados || []).map((oItem) => mOpcoes.find((oOpcao) => oOpcao.id === oItem.id) || oItem)

    setUsuariosSelecionados(mapearOpcoesSelecionadas(filters.users, users))
    setMotivos(mapearOpcoesSelecionadas(filters.motivo, motivos))
    setSituacoesSelecionadas(mapearOpcoesSelecionadas(filters.situacoes, situacoes))
    setEmpresa(filters.empresa || "")
    setLidas(filters.lidas !== undefined && filters.lidas !== null ? filters.lidas : true)
    setContatosSelecionados(filters.contatosSelecionados || [])
    setSearchParam("")

    const mFilasAtivas = filters.queues || []
    const lFilasPadraoUsuario =
      mFilasAtivas.length > 0 &&
      mFilasUsuario?.length > 0 &&
      JSON.stringify(mFilasAtivas.map((q) => q.id)) === JSON.stringify(mFilasUsuario.map((q) => q.id))

    if (lFilasPadraoUsuario || mFilasAtivas.length === 0) {
      setFilasSelecionadas([])
    } else {
      setFilasSelecionadas(mapearOpcoesSelecionadas(mFilasAtivas, queues))
    }
  }, [open, filters, users, queues, motivos, situacoes, mFilasUsuario])

  /**
   * Formata o label do contato para exibição
   */
  const renderLabelOpcao = (opcao) => {
    if (!opcao) return ""

    const cNome = opcao.nome || ""
    const cEmpresa = opcao.empresa || ""
    const cNumero = opcao.numero || ""

    if (cNumero) {
      return cEmpresa ? `${cNome} - ${cEmpresa}` : `${cNome} (${cNumero})`
    }
    return cNome
  }

  /**
   * Callback para atualizar contatos selecionados
   * O ContactList chama essa função com um callback (prev) => novoArray
   */
  const onMudancaContatos = (callbackOrValue) => {
    // O ContactList passa uma função callback, não o array diretamente
    if (typeof callbackOrValue === "function") {
      setContatosSelecionados(callbackOrValue)
    } else {
      setContatosSelecionados(callbackOrValue)
    }
  }

  const handleApplyFilters = () => {
    const contatosIds = mContatosSelecionados.map((contato) => contato.id)

    onApplyFilters({
      queues: mFilasSelecionadas.length > 0 ? mFilasSelecionadas : mFilasUsuario,
      situacoes: mSituacoesSelecionadas,
      users: mUsuariosSelecionados,
      empresa: cEmpresa,
      contatos: contatosIds,
      contatosSelecionados: mContatosSelecionados,
      motivo: mMotivos,
      lidas: lLidas,
    })
    onClose()
  }

  const onChangeUsers = (event, value, reason, details) => {
    const allItem = value.find((item) => item.id === 0)
    const allUsersSelected = users.every((user) => value.some((u) => u.id === user.id))

    if (details?.option.id === 0) {
      if (reason === "select-option") {
        setUsuariosSelecionados(users)
      } else if (reason === "remove-option") {
        setUsuariosSelecionados([])
      }
      return
    }

    if (allUsersSelected) {
      if (!allItem) {
        setUsuariosSelecionados([...value, { id: 0, name: "Todos" }])
      }
    } else {
      const newValue = value.filter((item) => item.id !== 0)
      setUsuariosSelecionados(newValue)
    }
  }

  const onChangeQueues = (event, value, reason, details) => {
    const allItem = value.find((item) => item.id === 0)
    const allQueuesSelected = queues.every((queue) => value.some((q) => q.id === queue.id))

    if (details?.option.id === 0) {
      if (reason === "select-option") {
        setFilasSelecionadas(queues)
      } else if (reason === "remove-option") {
        setFilasSelecionadas([])
      }
      return
    }

    if (allQueuesSelected) {
      if (!allItem) {
        setFilasSelecionadas([...value, { id: 0, name: "Todas" }])
      }
    } else {
      const newValue = value.filter((item) => item.id !== 0)
      setFilasSelecionadas(newValue)
    }
  }

  const onChangeSituacoes = (event, value, reason, details) => {
    const allItem = value.find((item) => item.id === 0)
    const allSituacoesSelected = situacoes.every((sit) => value.some((s) => s.id === sit.id))

    if (details?.option.id === 0) {
      if (reason === "select-option") {
        setSituacoesSelecionadas(situacoes)
      } else if (reason === "remove-option") {
        setSituacoesSelecionadas([])
      }
      return
    }

    if (allSituacoesSelected) {
      if (!allItem) {
        setSituacoesSelecionadas([...value, { id: 0, name: "Todas" }])
      }
    } else {
      const newValue = value.filter((item) => item.id !== 0)
      setSituacoesSelecionadas(newValue)
    }
  }

  const onChangeMotivos = (event, value, reason, details) => {
    const allItem = value.find((item) => item.id === 0)
    const allMotivosSelected = motivos.every((mot) => value.some((m) => m.id === mot.id))

    if (details?.option.id === 0) {
      if (reason === "select-option") {
        setMotivos(motivos)
      } else if (reason === "remove-option") {
        setMotivos([])
      }
      return
    }

    if (allMotivosSelected) {
      if (!allItem) {
        setMotivos([...value, { id: 0, descricao: "Todos" }])
      }
    } else {
      const newValue = value.filter((item) => item.id !== 0)
      setMotivos(newValue)
    }
  }

  const handleClearFilters = () => {
    setFilasSelecionadas([])
    setSituacoesSelecionadas([])
    setUsuariosSelecionados([])
    setEmpresa("")
    setMotivos([])
    setContatosSelecionados([])
    setLidas(true)
    setSearchParam("")
  }

  const Botoes = () => {
    return (
      <div className={classes.backgroundBotoes}>
        <div className={classes.buttonsContainer}>
          <DefaultButton stylization={"secondary"} onClick={handleClearFilters} className={classes.button}>
            Limpar filtros
          </DefaultButton>

          <DefaultButton stylization={"primary"} onClick={handleApplyFilters} className={classes.button}>
            Filtrar
          </DefaultButton>
        </div>
      </div>
    )
  }

  return (
    <Modal title="Filtrar conversas" modalOpen={open} onClose={onClose} footer={<Botoes />} scrollable={false}>
      <DialogContent className={classes.content}>
        <Grid container>
          <Grid item xs={12} className={classes.filterRow}>
            <Autocomplete
              multiple
              options={users}
              value={mUsuariosSelecionados}
              onChange={(e, v, r, d) => onChangeUsers(e, v, r, d)}
              disableCloseOnSelect
              getOptionLabel={(option) => option.name}
              className={classes.autocomplete}
              popupIcon={<ChevronDown className={classes.icon} strokeWidth={2.0} size={"24px"} />}
              renderOption={(props) => {
                const { key, menuOrdem, ...optionProps } = props
                const isSelected = mUsuariosSelecionados.some((user) => user.id === props.id)
                return (
                  <div
                    key={key}
                    {...optionProps}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                      flex: 1,
                      minWidth: 0,
                      overflow: "hidden",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>{props.name}</span>
                    <Checkbox multiplos={true} checked={isSelected} />
                  </div>
                )
              }}
              renderInput={(params) => {
                let placeholder = "Usuários"
                if (
                  mUsuariosSelecionados.length === users.length - 1 ||
                  mUsuariosSelecionados.some((user) => user.id === 0)
                ) {
                  placeholder = "Todos"
                } else if (mUsuariosSelecionados.length > 1) {
                  placeholder = "Vários"
                } else if (mUsuariosSelecionados.length === 1) {
                  placeholder = mUsuariosSelecionados[0].name
                }
                return (
                  <TextField {...params} variant="outlined" placeholder={placeholder} className={classes.textField} />
                )
              }}
              noOptionsText="Nenhum usuário encontrado"
              renderTags={() => null}
            />
          </Grid>

          <Grid item xs={12} className={classes.filterRow}>
            <ClickAwayListener
              onClickAway={() => {
                setAbrirDropdownContatos(false)
                setSearchParam("")
              }}
            >
              <div style={{ position: "relative" }}>
                <TextField
                  ref={contatoFieldRef}
                  variant="outlined"
                  fullWidth
                  value={abrirDropdownContatos || mContatosSelecionados.length > 0 ? searchParam : ""}
                  onClick={() => setAbrirDropdownContatos(true)}
                  onChange={(e) => setSearchParam(e.target.value)}
                  placeholder={
                    abrirDropdownContatos || mContatosSelecionados.length > 0
                      ? mContatosSelecionados.length > 1
                        ? `${mContatosSelecionados[0].nome || mContatosSelecionados[0].empresa || ""} e mais ${mContatosSelecionados.length - 1}`
                        : mContatosSelecionados.length === 1
                          ? renderLabelOpcao(mContatosSelecionados[0])
                          : ""
                      : "Pesquisar contato"
                  }
                  className={classes.searchContactField}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Search className={classes.icon} strokeWidth={2.0} size={"24px"} />
                      </InputAdornment>
                    ),
                  }}
                />
                <Popper
                  open={abrirDropdownContatos}
                  anchorEl={contatoFieldRef.current}
                  placement="bottom-start"
                  style={{ width: contatoFieldRef.current?.offsetWidth, zIndex: 9999 }}
                  modifiers={{
                    flip: {
                      enabled: true,
                    },
                    preventOverflow: {
                      enabled: true,
                      boundariesElement: "scrollParent",
                    },
                  }}
                >
                  <Paper
                    ref={contatoDropdownRef}
                    elevation={3}
                    className={classes.dropdownPaper}
                    style={{
                      maxHeight: "400px",
                      overflow: "auto",
                    }}
                  >
                    <ContactList
                      canalFilter={2}
                      multiplos={true}
                      searchParam={searchParam}
                      mContatosSelecionados={mContatosSelecionados}
                      setMContatosSelecionados={onMudancaContatos}
                      scrollContainerRef={contatoDropdownRef}
                    />
                  </Paper>
                </Popper>
              </div>
            </ClickAwayListener>
          </Grid>
          {location.pathname !== "/fluxo" && (
            <Grid item xs={12} className={classes.filterRow}>
              <Autocomplete
                multiple
                noOptionsText="Nenhum motivo encontrado"
                options={motivos}
                value={mMotivos}
                onChange={(e, v, r, d) => onChangeMotivos(e, v, r, d)}
                getOptionLabel={(option) => option.descricao}
                className={classes.autocomplete}
                disableCloseOnSelect
                popupIcon={<ChevronDown className={classes.icon} strokeWidth={2.0} size={"24px"} />}
                renderTags={() => null}
                renderOption={(props) => {
                  const { key, menuOrdem, ...optionProps } = props
                  const isSelected = mMotivos.some((motivo) => motivo.id === props.id)
                  return (
                    <div
                      key={key}
                      {...optionProps}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        flex: 1,
                        minWidth: 0,
                        overflow: "hidden",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>{props.descricao}</span>
                      <Checkbox multiplos={true} checked={isSelected} />
                    </div>
                  )
                }}
                renderInput={(params) => {
                  let placeholder = "Motivos"
                  if (mMotivos.length === motivos.length - 1 || mMotivos.some((mot) => mot.id === 0)) {
                    placeholder = "Todos"
                  } else if (mMotivos.length > 1) {
                    placeholder = "Vários"
                  } else if (mMotivos.length === 1) {
                    placeholder = mMotivos[0].descricao
                  }
                  return (
                    <TextField {...params} variant="outlined" placeholder={placeholder} className={classes.textField} />
                  )
                }}
              />
            </Grid>
          )}

          <Grid item xs={12} className={classes.filterRow}>
            <Autocomplete
              multiple
              options={queues}
              value={mFilasSelecionadas}
              onChange={(e, v, r, d) => onChangeQueues(e, v, r, d)}
              getOptionLabel={(option) => option.name}
              className={classes.autocomplete}
              popupIcon={<ChevronDown className={classes.icon} strokeWidth={2.0} size={"24px"} />}
              disableCloseOnSelect
              renderTags={() => null}
              renderOption={(props) => {
                const {
                  key,
                  greetingMessage,
                  outOfHoursMessage,
                  createdAt,
                  updatedAt,
                  companyId,
                  orderQueue,
                  integrationId,
                  promptId,
                  menuOrdem,
                  ...optionProps
                } = props
                const isSelected = mFilasSelecionadas.some((queue) => queue.id === props.id)
                return (
                  <div
                    key={key}
                    {...optionProps}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                      flex: 1,
                      minWidth: 0,
                      overflow: "hidden",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>{props.name}</span>
                    <Checkbox multiplos={true} checked={isSelected} />
                  </div>
                )
              }}
              noOptionsText="Nenhuma fila encontrada"
              renderInput={(params) => {
                let placeholder = "Filas"
                if (
                  mFilasSelecionadas.length === queues.length - 1 ||
                  mFilasSelecionadas.some((queue) => queue.id === 0)
                ) {
                  placeholder = "Todas"
                } else if (mFilasSelecionadas.length > 1) {
                  placeholder = "Várias"
                } else if (mFilasSelecionadas.length === 1) {
                  placeholder = mFilasSelecionadas[0].name
                }
                return (
                  <TextField {...params} variant="outlined" placeholder={placeholder} className={classes.textField} />
                )
              }}
            />
          </Grid>

          {location.pathname !== "/kanban" && (
            <Grid item xs={12} className={classes.filterRow}>
              <Autocomplete
                multiple
                options={situacoes}
                value={mSituacoesSelecionadas}
                onChange={(e, v, r, d) => onChangeSituacoes(e, v, r, d)}
                getOptionLabel={(option) => option.name}
                className={classes.autocomplete}
                disableCloseOnSelect
                popupIcon={<ChevronDown className={classes.icon} strokeWidth={2.0} size={"24px"} />}
                renderTags={() => null}
                noOptionsText="Nenhuma situação encontrada"
                renderOption={(props) => {
                  const { key, createdAt, updatedAt, companyId, padraoCerttus, ...optionProps } = props
                  const isSelected = mSituacoesSelecionadas.some((situacao) => situacao.id === props.id)
                  return (
                    <div
                      key={key}
                      {...optionProps}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        flex: 1,
                        minWidth: 0,
                        overflow: "hidden",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>{props.name}</span>
                      <Checkbox multiplos={true} checked={isSelected} />
                    </div>
                  )
                }}
                renderInput={(params) => {
                  let placeholder = "Situações"
                  if (
                    mSituacoesSelecionadas.length === situacoes.length - 1 ||
                    mSituacoesSelecionadas.some((sit) => sit.id === 0)
                  ) {
                    placeholder = "Todas"
                  } else if (mSituacoesSelecionadas.length > 1) {
                    placeholder = "Várias"
                  } else if (mSituacoesSelecionadas.length === 1) {
                    placeholder = mSituacoesSelecionadas[0].name
                  }
                  return (
                    <TextField {...params} variant="outlined" placeholder={placeholder} className={classes.textField} />
                  )
                }}
              />
            </Grid>
          )}

          <Grid item xs={12} className={classes.filterRow}>
            <div className={classes.checkboxGroup}>
              <div
                onClick={() => setLidas(true)}
                style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}
              >
                <Checkbox multiplos={false} checked={lLidas} />
                <span>Todas</span>
              </div>
              <div
                onClick={() => setLidas(false)}
                style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}
              >
                <Checkbox multiplos={false} checked={!lLidas} />
                <span>Não lidas</span>
              </div>
            </div>
          </Grid>
        </Grid>
      </DialogContent>
    </Modal>
  )
}

export default FilterModal
